import { render } from "./SentGeoModal.vue?vue&type=template&id=6976c118&scoped=true&ts=true"
import script from "./SentGeoModal.vue?vue&type=script&lang=ts"
export * from "./SentGeoModal.vue?vue&type=script&lang=ts"

import "./SentGeoModal.vue?vue&type=style&index=0&id=6976c118&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6976c118"]])

export default __exports__